import { render, staticRenderFns } from "./company__form.vue?vue&type=template&id=2fc992f2"
import script from "./company__form.vue?vue&type=script&lang=js"
export * from "./company__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports